import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import Select from "react-select";
import FormLabelText from "../FormLabelText";
// import DatePicker from "react-datepicker";
import MyInput from "../MyInput";
import { FixedSizeList as List } from "react-window";
import DatePickercomp from "../DatePicker";
import { useState } from "react";

const heightPerItem = 35;

const CustomMenuList = (props) => {
  const { children, maxHeight } = props;

  return (
    <List
      height={Math.min(maxHeight, children.length * heightPerItem)}
      width={300}
      itemCount={children.length}
      itemSize={heightPerItem}
    >
      {({ index, style }) => <div style={style}>{children[index]}</div>}
    </List>
  );
};

const DynamicFilter = ({
  fields = [],
  onChange,
  className = "pb-3",
  children,
}) => {
  // const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [freeSupervisorData, setFreeSupervisorData] = useState([]);
  const handleChange = (key, value) => {
    onChange && onChange(key, value);
  };

  // const fetchFreeSupervisorData = async (id) => {
  //   const res = await getSupervisorListWithTotalFreeUserByManagerId(id);
  //   if (res.status) {
  //     setFreeSupervisorData(res.data);
  //   } else {
  //     setFreeSupervisorData([]);
  //     toast.error(res.message);
  //   }
  // };

  const handleDateChange = (date) => {
    // const formatted = date?.toISOString().split("T")[0];
    setSelectedDate(date);
    console.log("date", date);
    handleChange("date", date);
  };

  function formatToDisplay(dateStr) {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  }

  function parseToISO(dateStr) {
    const [day, month, year] = dateStr.split("/");
    return `${year}-${month}-${day}`;
  }

  return (
    <div className={className}>
      <div className="shadow p-2 rounded">
        <Row className="g-2 align-items-end">
          {fields?.map((field, index) => (
            <Col md={field.col || 3} key={index}>
              <FormLabelText>{field.label}</FormLabelText>

              {field.type === "text" ? (
                // A plain search box that sits in the same row as the selects,
                // for the lists whose first filter is a name rather than a
                // pick. Debouncing is the caller's job — this only reports what
                // was typed. Plain Form.Control rather than MyInput, because
                // MyInput is a Formik field and this bar has no Formik context.
                <Form.Control
                  type="text"
                  value={field.value || ""}
                  placeholder={field.placeholder || field.label}
                  onChange={(e) => handleChange(field.key, e.target.value)}
                />
              ) : field.type === "date" ? (
                <DatePickercomp
                  value={field.value}
                  label={field.label}
                  key={field.key}
                  // Range bounds for cross-field date validation (e.g. To-Date
                  // can't be before From-Date). Optional per field.
                  minDate={field.minDate}
                  maxDate={field.maxDate}
                  allowFutureDates={field.allowFutureDates}
                  sendDate={(date) => handleChange(field.key, date)}
                />
              ) : (
                <Select
                  menuPortalTarget={document.body}
                  options={
                    field.options && field.options.length > 0
                      ? field.options
                      : [{ label: "No Data Found", value: "" }]
                  }
                  onChange={(e) => handleChange(field.key, e ? e.value : null)}
                  isClearable
                  // Optional per-field custom option renderer (e.g. show a small
                  // secondary line under the label). Only set when provided so
                  // existing fields keep react-select's default rendering.
                  {...(field.formatOptionLabel
                    ? { formatOptionLabel: field.formatOptionLabel }
                    : {})}
                  components={{ MenuList: CustomMenuList }}
                  value={
                    field.options?.find((opt) => opt.value === field.value) ||
                    null
                  }
                />
              )}
            </Col>
          ))}
          {children}
        </Row>
      </div>
    </div>
  );
};

export default DynamicFilter;
